import script from "./section9-parallax.vue?vue&type=script&setup=true&lang=js"
export * from "./section9-parallax.vue?vue&type=script&setup=true&lang=js"

import "./section9-parallax.vue?vue&type=style&index=0&id=449da6ac&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-449da6ac"]])

export default __exports__